import axios from "axios";

export type TCenterVerifyOAuthTokenRes = {
  data: {
    accessToken: string;
    refreshToken: string;
    expiresIn: number;
    email: string;
    userId: number;
    ownerId: number;
    isUser?: boolean;
    externalId?: string;
  };
};

const centerApi = axios.create({
  baseURL: process.env.REACT_APP_CENTER_API_HOST,
});

export const verifyCenterOAuthToken = async (token: string): Promise<TCenterVerifyOAuthTokenRes["data"]> => {
  const { data } = await centerApi.post<TCenterVerifyOAuthTokenRes>("/oauth/verify-token", { token });
  return data.data;
};

export type TCenterRefreshTokenRes = {
  data: {
    accessToken: string;
    expiresIn: number;
    refreshToken: string;
  };
};

export const refreshCenterOAuthToken = async (accessToken: string, refreshToken: string): Promise<TCenterRefreshTokenRes["data"]> => {
  const { data } = await centerApi.post<TCenterRefreshTokenRes>("/refresh-token", { accessToken, refreshToken });
  return data.data;
};
